module.exports = __webpack_public_path__ + "static/media/text-size.ca425d25.svg";